var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-main",
    { staticClass: "sm-max-p-0 sm-and-down-mt-56" },
    _vm._l(_vm.getAgentNotifications, function (notification, i) {
      return _c(
        "v-app-bar",
        {
          key: i,
          staticClass: "pt-2",
          attrs: { color: "black", dark: "", "min-height": "80" },
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                { attrs: { align: "center" } },
                [
                  _c(
                    "div",
                    { staticClass: "sm-and-down-w-100 text-truncate" },
                    [
                      _c("h3", { staticClass: "text-truncate" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(notification.text) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-0 hidden-sm-and-down" }, [
                        _c("strong"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "hidden-sm-and-down black--text",
                      attrs: {
                        to: {
                          name: "tickets",
                          query: {
                            inmediate_attention: true,
                          },
                        },
                        color: "accent",
                        rounded: "",
                      },
                    },
                    [_vm._v("\n          Ver oportunidades\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "hidden-md-and-up black--text",
                      attrs: { color: "accent", "x-small": "", rounded: "" },
                    },
                    [_vm._v(" Ver oportunidades ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }